package com.eladfinish.bible.contest.screens.misc

import com.eladfinish.bible.contest.analytics.crashlytics.AppCrashlytics
import com.eladfinish.bible.contest.arch.ViewModelStore
import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.extensions.getFormattedDate
import com.russhwolf.settings.Settings
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.contentOrNull
import kotlinx.serialization.json.jsonArray
import kotlin.time.Clock

class MiscStore(
    private val settings: Settings,
) : ViewModelStore<MiscState, MiscAction, MiscEffect>(tag = "MiscViewModel") {

    override val stateFlow = MutableStateFlow(MiscState)

    override fun handleAction(action: MiscAction): MiscState =
        when (action) {
            MiscAction.SeminarClicked -> handleSeminarClicked()
        }

    private fun handleSeminarClicked(): MiscState {
        launchEffect { sideEffectFlow.emit(resolveSeminarEffect()) }
        return currentState
    }

    private fun resolveSeminarEffect(): MiscEffect {
        val timezone = TimeZone.currentSystemDefault()
        val now = Clock.System.now().toLocalDateTime(timezone).date
        val datesJson = settings.getString(Constants.DATES_OF_FREE_MIKUD, "[]")
        val currentDate = now.getFormattedDate("dd.MM.yyyy")
        val sb = StringBuilder()

        return try {
            val datesArray = Json.parseToJsonElement(datesJson).jsonArray

            if (datesArray.isEmpty()) return MiscEffect.NavigateToSeminar

            sb.append("אפשרות זו זמינה בתאריכים הבאים:\n")
            for (element in datesArray) {
                val date = (element as? JsonPrimitive)?.contentOrNull ?: continue
                sb.append(date).append("\n")
                if (date == currentDate) return MiscEffect.NavigateToSeminar
            }

            MiscEffect.ShowMessage(sb.toString().trim())
        } catch (e: Exception) {
            AppCrashlytics.logException(e)
            MiscEffect.ShowMessage(e.message ?: "שגיאה לא ידועה")
        }
    }
}
